interface ICreditAdjustActionConfig {
  minAmount: number
  projectedBalance: (currentBalance: number, amount: number) => number
  amountLabelKey: string
  minErrorKey: string
}

class CreditsService {
  readonly adminAdjustActions = {
    add: {
      minAmount: 1,
      projectedBalance: (currentBalance, amount) => currentBalance + amount,
      amountLabelKey: 'admin.credits.adjust.amountLabel',
      minErrorKey: 'admin.credits.adjust.errors.notPositive'
    },
    override: {
      minAmount: 0,
      projectedBalance: (_currentBalance, amount) => amount,
      amountLabelKey: 'admin.credits.adjust.newBalanceLabel',
      minErrorKey: 'admin.credits.adjust.errors.negativeBalance'
    }
  } as const satisfies Record<TAdminAdjustAction, ICreditAdjustActionConfig>

  async getCredits () {
    return apiClient.get('/api/me/credits/')
  }

  async lookupRecipient (phone: string) {
    return apiClient.post('/api/transfer/lookup/', { phone })
  }

  async createTransfer (body: TCreateTransferBody) {
    return apiClient.post('/api/transfer/', body)
  }
}

export const creditsService = new CreditsService()
